import { skipToken } from '@reduxjs/toolkit/query';
import { useOnMissionV3SubscriptionQuery } from 'services/missionV3';

interface Props {
    vin?: string;
}

const useGetMissionData = ({ vin }: Props) => {
    // `currentData`, not `data`, on purpose. RTK Query's `data` is the last known good value across
    // hook args, so when the request for a new vin fails it silently serves the previous vin's mission
    // and the page shows another vehicle's mission and event log as if it were this one's.
    // `currentData` only ever holds the value for the vin that was asked for, so a failure yields
    // nothing and callers can show a loading or error state instead of stale data.
    // `currentData` is undefined while a request is in flight, so use `isFetching` for loading states
    // and never read "no data yet" as "no mission".
    const { currentData, isFetching, isError, error } = useOnMissionV3SubscriptionQuery(vin ?? skipToken);

    return {
        data: currentData,
        isFetching,
        isError,
        error,
    };
};

export default useGetMissionData;
